import type { ReactNode } from "react";

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: ReactNode;
}) {
  return (
    <div
      className={`flex flex-col gap-4 ${
        align === "center" ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={align === "center" ? "max-w-2xl" : ""}>
        {eyebrow && (
          <p
            className={`flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-600 uppercase mb-3 ${
              align === "center" ? "justify-center" : ""
            }`}
          >
            {align === "center" ? null : <span className="w-6 h-px bg-primary-500 inline-block" />}
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl md:text-4xl tracking-wide text-foreground-950">{title}</h2>
        {desc && <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action}
    </div>
  );
}